import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listBaselines = async (
  companyId: string,
  companyType: string,
  projectId: number
) =>
  post("projectService/baseline/listBaselines", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
  });

export const createBaseline = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/baseline/createBaseline", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const getBaselineDetail = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/baseline/getBaselineDetail", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const deleteBaseline = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/baseline/deleteBaseline", {
    company_id: companyId,
    company_type: companyType,
    id,
  });
